import Mention from '@tiptap/extension-mention';
import type { SuggestionOptions } from '@tiptap/suggestion';
import type { UserSuggestion } from '../types';

const CustomMention = Mention.extend({
  addAttributes() {
    return {
      // Mention attrs persist as JSON via TipTap; only userId is mirrored to DOM as data-mention.
      userId: {
        default: null,
        parseHTML: (el: HTMLElement) => el.getAttribute('data-mention'),
        renderHTML: (attrs: Record<string, unknown>) =>
          attrs.userId ? { 'data-mention': attrs.userId as string } : {},
      },
      label: {
        default: null,
        parseHTML: (el: HTMLElement) => el.getAttribute('data-mention-label'),
        // No renderHTML — label is recovered from text content on paste; node JSON carries it via attrs.
      },
    };
  },
});

export function buildMentionExtension(
  searchUsers: (q: string) => Promise<UserSuggestion[]>,
  renderPopup: SuggestionOptions['render'],
) {
  return CustomMention.configure({
    HTMLAttributes: { class: 'mention rounded bg-primary/10 text-primary px-1' },
    renderText({ node }) {
      return `@${node.attrs.label ?? ''}`;
    },
    renderHTML({ options, node }) {
      return ['span', { ...options.HTMLAttributes, 'data-mention': node.attrs.userId }, `@${node.attrs.label}`];
    },
    suggestion: {
      char: '@',
      items: async ({ query }) => {
        if (!query) return [];
        return searchUsers(query);
      },
      render: renderPopup,
    },
  });
}
